// extracted by mini-css-extract-plugin
export default {"menuLink":"menu-link_menuLink__SsFNl","iconContainer":"menu-link_iconContainer__de9c0","labelContainer":"menu-link_labelContainer__FncaA","dashIcon":"menu-link_dashIcon__SRenr"};